import { useEffect, useState } from "react";
import moment from "moment";
import axiosInstance from "./axios/axios";
import { Encrypt_Value, Decrypt_Value } from "./MiddleWare/EncryptDecrypt";

const useLogout = (startTime) => {
  const SLEEP_LIMIT = 60 * (startTime + 2) * 1000;
  const [timer, setTimer] = useState(startTime);
  const [showSessionModal, setShowSessionModal] = useState(false);
  const [popupSeconds, setPopupSeconds] = useState(300);
  const [token_exp_times, settoken_exp_times] = useState(
    moment(localStorage.getItem("login_time") || "").format(
      "YYYY-MM-DD HH:mm A",
    ),
  );

  // ===================== REFRESH TOKEN =====================
  const refreshToken = () => {
    const client_id = process.env.REACT_APP_BACKEND_CLIENT_ID;
    const refresh_token = localStorage.getItem("refresh_token");

    const details = {
      grant_type: "refresh_token",
      client_id,
      refresh_token,
    };

    const Encrypt_details = Encrypt_Value(details, "vozo");

    axiosInstance({
      method: "post",
      url: "/vozo/refresh",
      data: Encrypt_details,
    })
      .then((response) => {
        const Decrpt_response = Decrypt_Value(response.data, "vozo");

        localStorage.setItem("token", Decrpt_response.token);
        localStorage.setItem("refresh_token", Decrpt_response.refresh_token);
        localStorage.setItem("login_time", Decrpt_response.token_exp);

        settoken_exp_times(
          moment(Decrpt_response.token_exp).format("YYYY-MM-DD HH:mm A"),
        );

        setShowSessionModal(false);
        setPopupSeconds(300);
      })
      .catch(() => {
        let firstDot = window.location.hostname.split(".");
        if (
          firstDot[0] === "localhost" ||
          firstDot[0] === "saravana" ||
          firstDot[0] === "production"
        ) {
          alert("We couldn’t verify your session. Please sign in again.");
        }

        localStorage.clear();
        window.location.href = "/";
      });
  };

  useEffect(() => {
    // ===================== INITIALIZE LAST ACTIVE =====================
    if (!localStorage.getItem("lastActiveTime")) {
      localStorage.setItem("lastActiveTime", Date.now());
    }

    // ===================== CHECK TOKEN EXPIRY =====================
    const CurrTimes = moment().add(3, "m").format("YYYY-MM-DD HH:mm A");

    if (token_exp_times === CurrTimes) {
      refreshToken();
    }

    // ===================== SLEEP DETECTION =====================
    const checkSleepTimeout = () => {
      const lastActive = localStorage.getItem("lastActiveTime");
      if (!lastActive) return;

      const diff = Date.now() - Number(lastActive);

      if (diff > SLEEP_LIMIT) {
        let firstDot = window.location.hostname.split(".");
        if (
          firstDot[0] === "localhost" ||
          firstDot[0] === "saravana" ||
          firstDot[0] === "production"
        ) {
          alert(
            "For security reasons, your session has ended due to inactivity. Please sign in again.",
          );
        }

        localStorage.clear();
        window.location.href = "/";
      }
    };

    // ===================== TIMER (INACTIVITY COUNTDOWN) =====================
    const myInterval = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer <= 0) return 0;

        const newTimer = prevTimer - 1;

        if (newTimer === 5) {
          setShowSessionModal(true);
        }

        return newTimer;
      });
    }, 60000); // 1 minute

    // ===================== POPUP COUNTDOWN =====================
    const popupInterval = setInterval(() => {
      if (showSessionModal && popupSeconds > 0) {
        setPopupSeconds((prev) => prev - 1);
      }

      if (showSessionModal && popupSeconds === 1) {
        localStorage.clear();
        window.location.href = "/";
      }
    }, 1000);

    const handleVisibility = () => {
      if (document.visibilityState === "visible") {
        checkSleepTimeout();
      }
    };

    // ===================== RESET ON USER ACTIVITY =====================
    const resetTimeout = () => {
      localStorage.setItem("lastActiveTime", Date.now());

      // Only reset inactivity timer if modal is NOT visible
      if (!showSessionModal) {
        setTimer(startTime);
        setPopupSeconds(300);
      }
    };

    const events = [
      "load",
      "mousemove",
      "mousedown",
      "click",
      "scroll",
      "keypress",
    ];

    events.forEach((event) => window.addEventListener(event, resetTimeout));

    // Detect wake from sleep
    window.addEventListener("focus", checkSleepTimeout);
    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      clearInterval(myInterval);
      clearInterval(popupInterval);

      events.forEach((event) =>
        window.removeEventListener(event, resetTimeout),
      );

      window.removeEventListener("focus", checkSleepTimeout);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, [startTime, showSessionModal, popupSeconds, token_exp_times]);

  return {
    timer,
    showSessionModal,
    popupSeconds,
    refreshToken,
    setShowSessionModal,
  };
};

export default useLogout;
